import React from 'react';
import SettingIcon from './SettingIcon';
import { useIsInIframe } from '../../hooks/use-is-in-iframe';

export function ErrorModal({
  title = 'Unknown Error',
  message,
  isDismissable = false,
  onDismiss = Function.prototype,
  actionButton,
}) {
  const isInIframe = useIsInIframe();

  return (
    <div className="as-Error-body">
      {isDismissable && (
        <button
          type="button"
          className="as-Error-dismissButton"
          onClick={onDismiss}
        >
          <shore-icon name="delete" />
        </button>
      )}
      <h2 className="as-Error-title">{title}</h2>
      {!isInIframe && (
        <p
          className="as-Error-message"
          dangerouslySetInnerHTML={{ __html: message }}
        />
      )}

      <div className="as-Error-icon">
        <SettingIcon />
      </div>
      {!isInIframe && actionButton && (
        <a href={actionButton.href} className="as-Error-actionButton">
          {actionButton.title}
        </a>
      )}
    </div>
  );
}
